var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-back-top"},[(!_vm.isTop)?_c('div',[_c('span',{staticClass:"iconfont",on:{"click":function($event){return _vm.goBackTop()}}},[_vm._v("")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }